'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var FlickityController = exports.FlickityController = function () {
    function FlickityController(FlickityConfig) {
        'ngInject';

        _classCallCheck(this, FlickityController);

        this.FlickityConfig = FlickityConfig;

        this._activate();
    }

    _createClass(FlickityController, [{
        key: '_activate',
        value: function _activate() {

            // Extend the default options with user configuration
            this.options = angular.extend({}, this.FlickityConfig, angular.fromJson(this.bcFlickity));
        }
    }]);

    return FlickityController;
}();


/** WEBPACK FOOTER **
 ** ./src/flickity.controller.js
 **/